import { db } from '../firebase-config'
import { getDoc, doc } from 'firebase/firestore/lite'
import axios from 'axios'

export default function useVenuesApi () {
  const getAxiosInstance = () => {
    const baseURL = process.env.REACT_APP_CLOUD_FUNCTION_GAMES_BASE_URL
    return axios.create({ baseURL })
  }

  const getVenue = async (id) => {
    const docSnap = await getDoc(doc(db, 'venues', id))
    if (docSnap.exists()) {
      return docSnap.data()
    } else {
      console.error(`No venue exists with ID ${id}`)
    }
  }

  const getLeaderboardForVenue = async (venueId) => {
    const venue = getVenue(venueId)
    if (venue) {
      const client = getAxiosInstance()
      try {
        const leaderboard = await client.get(`/leaderboard/${venueId}`)
        return leaderboard.data
      } catch (err) {
        console.error(`Unable to fetch leaderboard for venue ${venueId}`, err)
      }
    }
  }

  const initiateGameSession = async (venueId, playerName, gameId) => {
    const venue = getVenue(venueId)
    if (venue) {
      const client = getAxiosInstance()
      try {
        const res = await client.post(
          '/initiate',
          {
            game_id: gameId,
            player_name: playerName,
            venue_id: venueId
          }
        )
        const resData = res.data
        if (resData.error) {
          console.error('Unable to initiate game session', resData.error)
          throw Error(`Unable to initiate game session: ${resData.error}`)
        }
        if (!resData.response) {
          console.error('Unable to initiate game session, empty response', resData)
          throw Error('Unable to initiate game session: empty response from server')
        }
        return resData.response
      } catch (err) {
        console.error('Unable to initiate game session', err)
        throw Error(
          err?.response?.data?.error
            ? err.response.data.error
            : 'Unable to initiate game session'
        )
      }
    } else {
      console.error(`Venue ${venueId} not found`)
      throw Error(`Unable to initiate game session: venue ${venueId} not found`)
    }
  }

  const submitEmailForGameSession = async (gameSessionId, email, marketingFlag) => {
    const client = getAxiosInstance()
    try {
      const res = await client.post(
        `/submit-email/${gameSessionId}`,
        {
          email,
          marketing_list: marketingFlag
        }
      )
      const resData = res.data
      if (resData.error) {
        console.error('Unable to submit game session email details', resData.error)
        throw Error(`Unable to submit game session email details: ${resData.error}`)
      }
      return true
    } catch (err) {
      console.error(`Unable to submit game session email details for session ${gameSessionId}`, err)
      throw Error(
        err?.response?.data?.error
          ? err.response.data.error
          : 'Unable to submit game session email details'
      )
    }
  }

  const submitScoresForGameSession = async (gameSessionId, score) => {
    const client = getAxiosInstance()
    try {
      const res = await client.post(
        `/submit-scores/${gameSessionId}`,
        {
          total_score: score
        }
      )
      const resData = res.data
      if (resData.error) {
        console.error('Unable to submit game session score', resData.error)
        throw Error(`Unable to submit game session score: ${resData.error}`)
      }
      return true
    } catch (err) {
      console.error(`Unable to submit game session score for session ${gameSessionId}`, err)
      throw Error(
        err?.response?.data?.error
          ? err.response.data.error
          : 'Unable to submit game session score'
      )
    }
  }

  return { getLeaderboardForVenue, getVenue, initiateGameSession, submitEmailForGameSession, submitScoresForGameSession }
}
